module.exports = __webpack_public_path__ + "static/img/SNK1.626bd8c6.jpg";